export const COMPLETED_JOB: string = 'COMPLETED_JOB'



// WEBPACK FOOTER //
// ./src/constants/completedJob-consts.ts